import { FieldArray, getIn } from 'formik';
import SectionHeader from '../../../components/SectionHeader';
import { useTranslation } from 'react-i18next';
import PageSection from './PageSection';
import { useState } from 'react';
import { ISection } from '../types/interfaces';
import { plusIcon } from '../../../config/variables';
import Button from '../../../components/buttons/Button';

export default function PageSubSections({ sectionName }: { sectionName: string }) {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(-1);

  return (
    <FieldArray
      name={`${sectionName}.sub_sections`}
      render={(arrayHelpers) => {
        const subSections = getIn(arrayHelpers?.form?.values, `${sectionName}.sub_sections`) as ISection[];
        return (
          <SectionHeader title={t('sub_sections')} customStyle="last sub_sections">
            {!!subSections?.length && (
              <div className="accordions-container">
                {subSections?.map((section, index) => {
                  return <PageSection arrayHelpers={arrayHelpers} data={section} expanded={expanded} setExpanded={setExpanded} index={index} namePref={sectionName} subSection />;
                })}
              </div>
            )}
            <Button
              customClass="add-section_btn"
              onClick={() => {
                arrayHelpers?.push({});
              }}
            >
              <div className="add-section_btn_content">
                {plusIcon} {t('add_sub_section')}
              </div>
            </Button>
          </SectionHeader>
        );
      }}
    />
  );
}
